export default __webpack_public_path__ + "static/media/Ballroll_00363.082aaddd.png";